import React from 'react';
import { isMobile } from 'react-device-detect';
import {
    ComposableMap,
    Geographies,
    Geography,
    Annotation,
} from 'react-simple-maps';
import { ConnectorLine, ConnectorEndDot } from 'react-annotation';

import { doesCountryHost, hostsData } from './hostsData';
import { petrol, yellow } from '../../constants/colors';
import europeGeoData from '../../constants/europeGeoData.json';

const InteractiveMap = ({ selectedCountry, setSelectedCountry }) => {
    const handleCountrySelection = (event, country) => {
        doesCountryHost(country) && setSelectedCountry(event.target.id);
    };
    const baseColor = yellow;
    const highLightColor = '#fcf0ae';
    const hoverHighlightColor = '#FFC800'; //'#fcf0ae';
    const textColor = petrol;
    const textHighLight = petrol;
    return (
        <div
            id="interactive-map"
            className="relative mx-auto w-[100%] md:w-3/4 md:mx-auto mb-16 mt-8 px-4 md:px-0"
        >
            <div className="border border-gray-400 shadow-xl overflow-hidden bg-slate-300">
                <ComposableMap
                    width={isMobile ? 350 : 700}
                    height={350}
                    projection="geoMercator"
                    projectionConfig={{
                        rotate: [0, 0, 0],
                        scale: isMobile ? 800 : 600,
                        center: [17, 48],
                    }}
                >
                    <Geographies geography={europeGeoData}>
                        {({ geographies }) =>
                            geographies.map((geo) => (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    id={geo.properties.geounit}
                                    style={{
                                        default: {
                                            fill:
                                                geo.properties.geounit ===
                                                selectedCountry
                                                    ? highLightColor
                                                    : doesCountryHost(
                                                          geo.properties.geounit
                                                      )
                                                    ? baseColor
                                                    : petrol,
                                        },
                                        hover: {
                                            fill:
                                                geo.properties.geounit ===
                                                selectedCountry
                                                    ? highLightColor
                                                    : doesCountryHost(
                                                          geo.properties.geounit
                                                      )
                                                    ? hoverHighlightColor
                                                    : petrol,
                                        },
                                        pressed: {
                                            fill:
                                                geo.properties.geounit ===
                                                selectedCountry
                                                    ? highLightColor
                                                    : doesCountryHost(
                                                          geo.properties.geounit
                                                      )
                                                    ? hoverHighlightColor
                                                    : petrol,
                                        },
                                    }}
                                    stroke={'#eaeaec'}
                                    className={`rounded-full focus:border-none focus:outline-none ${
                                        doesCountryHost(
                                            geo.properties.geounit
                                        ) && 'cursor-pointer'
                                    }`}
                                    onClick={(event) =>
                                        handleCountrySelection(
                                            event,
                                            geo.properties.geounit
                                        )
                                    }
                                />
                            ))
                        }
                    </Geographies>

                    {hostsData.map((host) => {
                        return (
                            <Annotation
                                key={host.id}
                                subject={host.coordinates}
                                dx={0}
                                dy={-5}
                                connectorProps={{
                                    type: 'line',
                                    end: 'dot',
                                    stroke: '#000',
                                    fill: '#000',
                                    color: '#000',
                                    strokeWidth: 1,
                                    strokeLinecap: 'round',
                                }}
                            >
                                {/*
                                    TODO:   Bugfix
                                                The ConnectorLine or the ConnectorEndDot component result in the following Error Message in the Console:
                                                Error: <path> attribute d: Expected number, "M0,0LNaN,NaN".
                                */}
                                <ConnectorLine>
                                    <ConnectorEndDot />
                                </ConnectorLine>
                                {
                                    <text
                                        x={
                                            isMobile
                                                ? host.mobileX
                                                : host.labelX
                                        }
                                        y={
                                            isMobile
                                                ? host.mobileY
                                                : host.labelY
                                        }
                                        textAnchor="end"
                                        alignmentBaseline="middle"
                                        fill={
                                            selectedCountry === host.country
                                                ? textColor
                                                : textHighLight
                                        }
                                        fontSize={isMobile ? '16px' : '12px'}
                                        fontWeight={isMobile ? 700 : 500}
                                        pointerEvents="none"
                                        // fontFamily=''
                                    >
                                        {host.city}
                                    </text>
                                }
                            </Annotation>
                        );
                    })}
                </ComposableMap>
            </div>
            <div
                className="absolute -top-2 left-6 -bottom-3 right-8 md:-top-3 md:left-5 md:-bottom-5 md:-right-5
                            border-2 border-dashed border-primary2 bg-primary2/20 -z-10"
            ></div>
            <div
                className="absolute -top-5 left-10 -bottom-6 right-5 md:top-10 md:left-10
                            bg-primary1/25 -z-10 md:h-full md:w-full"
            ></div>
        </div>
    );
};

export default InteractiveMap;
